// extracted by mini-css-extract-plugin
export default {"express_checkout":"ky","buttons":"ly","stripe":"my","or_title":"ny","line":"oy","express_checkout_title":"py","center_block":"qy"};
    if(module.hot) {
      // 1713912565682
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  